import { COMMON_ACTION_BUTTONS } from '../../common';

export const STAND_WORKSHEET_ACTION_BUTTONS = [
  {
    ...COMMON_ACTION_BUTTONS.Reopen,
    permissionCodes: ['VenuesInventory.StandWorksheet.Manage'],
  },
  COMMON_ACTION_BUTTONS.View,
  {
    ...COMMON_ACTION_BUTTONS.Edit,
    permissionCodes: ['VenuesInventory.StandWorksheet.Manage'],
  },
  COMMON_ACTION_BUTTONS.Print,
  COMMON_ACTION_BUTTONS.Export,
];
